// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/supply_48_data_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { SupplyCategory } from "../../bfftypes/v1/supply_category_pb";
import { file_bfftypes_v1_supply_category } from "../../bfftypes/v1/supply_category_pb";
import type { GateCloseFrontier } from "./gate_close_model_pb";
import { file_bffuser_v1_gate_close_model } from "./gate_close_model_pb";
import type { GateCloseInfo, ImportSupply48DataRow, SavedSupply48DataRow, SaveSupply48DataRow, Supply48DataSource } from "./supply_48_data_model_pb";
import { file_bffuser_v1_supply_48_data_model } from "./supply_48_data_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/supply_48_data_service.proto.
 */
export const file_bffuser_v1_supply_48_data_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_side, file_bfftypes_v1_supply_category, file_bffuser_v1_gate_close_model, file_bffuser_v1_supply_48_data_model, file_buf_validate_validate, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListSupply48DataRequest
 */
export type ListSupply48DataRequest = Message<"bffuser.v1.ListSupply48DataRequest"> & {
  /**
   * 売買区分 (必須)。
   *
   * @generated from field: bfftypes.v1.Side buy_sell = 1;
   */
  buySell: Side;

  /**
   * 表示中のカテゴリタブ (1 タブ = 1 リクエスト)。
   *
   * @generated from field: bfftypes.v1.SupplyCategory category = 2;
   */
  category: SupplyCategory;

  /**
   * エリアコード (単一選択)。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * 期間開始日。期間上限 (1 ヶ月 + 前日比較 +1 日) は usecase で検証 (CEL 不使用)。
   *
   * @generated from field: google.type.Date date_from = 4;
   */
  dateFrom?: Date;

  /**
   * 期間終了日。
   *
   * @generated from field: google.type.Date date_to = 5;
   */
  dateTo?: Date;
};

/**
 * Describes the message bffuser.v1.ListSupply48DataRequest.
 * Use `create(ListSupply48DataRequestSchema)` to create a new message.
 */
export const ListSupply48DataRequestSchema: GenMessage<ListSupply48DataRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_service, 0);

/**
 * @generated from message bffuser.v1.ListSupply48DataResponse
 */
export type ListSupply48DataResponse = Message<"bffuser.v1.ListSupply48DataResponse"> & {
  /**
   * 供給源単位の 48 点データ一覧 (旧 legs、supply-48-source-redesign で改名)。
   *
   * @generated from field: repeated bffuser.v1.Supply48DataSource sources = 1;
   */
  sources: Supply48DataSource[];

  /**
   * Deprecated: gate_close_frontier を使う。日跨ぎの判定 (今日 / 翌日の比較) を client に
   * 残す形のため置き換えた。配備済みの旧 frontend 向けに値は引き続き詰める。
   *
   * @generated from field: bffuser.v1.GateCloseInfo gate_close = 2 [deprecated = true];
   * @deprecated
   */
  gateClose?: GateCloseInfo;

  /**
   * 応答を作った時刻のゲートクローズ境界。セルの GC ロック判定に使う。
   *
   * @generated from field: bffuser.v1.GateCloseFrontier gate_close_frontier = 3;
   */
  gateCloseFrontier?: GateCloseFrontier;
};

/**
 * Describes the message bffuser.v1.ListSupply48DataResponse.
 * Use `create(ListSupply48DataResponseSchema)` to create a new message.
 */
export const ListSupply48DataResponseSchema: GenMessage<ListSupply48DataResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_service, 1);

/**
 * @generated from message bffuser.v1.SaveSupply48DataRequest
 */
export type SaveSupply48DataRequest = Message<"bffuser.v1.SaveSupply48DataRequest"> & {
  /**
   * 保存する行の一覧 (1 件以上、10000 件以下)。
   * max_items = usecase の maxSaveRows (go/internal/backend/application/usecase/supply/supply_48_data.go) と同期。
   *
   * @generated from field: repeated bffuser.v1.SaveSupply48DataRow rows = 1;
   */
  rows: SaveSupply48DataRow[];

  /**
   * true = 時間帯区分整合の警告 (AC-S4D-045) を確認済みとして保存を許可する。
   * false (既定) で違反があれば FailedPrecondition ([S4D-045] prefix 付きの
   * spec 文言) を返し、client は確認ダイアログを経て true で再送する
   * (docs/specs/supply/supply-48-data.md AC-S4D-045)。
   *
   * @generated from field: bool confirm_inactive_koma = 2;
   */
  confirmInactiveKoma: boolean;
};

/**
 * Describes the message bffuser.v1.SaveSupply48DataRequest.
 * Use `create(SaveSupply48DataRequestSchema)` to create a new message.
 */
export const SaveSupply48DataRequestSchema: GenMessage<SaveSupply48DataRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_service, 2);

/**
 * @generated from message bffuser.v1.SaveSupply48DataResponse
 */
export type SaveSupply48DataResponse = Message<"bffuser.v1.SaveSupply48DataResponse"> & {
  /**
   * 保存後の各行の新 updated_at トークン。
   *
   * @generated from field: repeated bffuser.v1.SavedSupply48DataRow rows = 1;
   */
  rows: SavedSupply48DataRow[];
};

/**
 * Describes the message bffuser.v1.SaveSupply48DataResponse.
 * Use `create(SaveSupply48DataResponseSchema)` to create a new message.
 */
export const SaveSupply48DataResponseSchema: GenMessage<SaveSupply48DataResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_service, 3);

/**
 * @generated from message bffuser.v1.ImportSupply48DataRequest
 */
export type ImportSupply48DataRequest = Message<"bffuser.v1.ImportSupply48DataRequest"> & {
  /**
   * 取込対象の全行 (1 件以上、上限 5,000 行)。
   *
   * @generated from field: repeated bffuser.v1.ImportSupply48DataRow rows = 1;
   */
  rows: ImportSupply48DataRow[];

  /**
   * true = プレビュー (検証・差分計算のみ、反映なし・冪等)。false = 確定 (再検証の上反映)。
   *
   * @generated from field: bool dry_run = 2;
   */
  dryRun: boolean;

  /**
   * 投入 CSV ファイル名 (csv_upload_history.csv_file_name に記録。
   * ADR csv-upload-history-best-effort-recording.md)。任意。
   *
   * @generated from field: optional string csv_file_name = 3;
   */
  csvFileName?: string;
};

/**
 * Describes the message bffuser.v1.ImportSupply48DataRequest.
 * Use `create(ImportSupply48DataRequestSchema)` to create a new message.
 */
export const ImportSupply48DataRequestSchema: GenMessage<ImportSupply48DataRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_service, 4);

/**
 * ImportSupply48DataRowResult は取込行 1 行の結果 (プレビュー / 確定共通)。
 *
 * @generated from message bffuser.v1.ImportSupply48DataRowResult
 */
export type ImportSupply48DataRowResult = Message<"bffuser.v1.ImportSupply48DataRowResult"> & {
  /**
   * @generated from field: int32 row_number = 1;
   */
  rowNumber: number;

  /**
   * @generated from field: bffuser.v1.ImportSupply48DataRowStatus status = 2;
   */
  status: ImportSupply48DataRowStatus;

  /**
   * 以下は取引ID → contract 解決成功時のみ設定 (ERROR で解決失敗時は unset / 空)。
   *
   * @generated from field: bfftypes.v1.Side buy_sell = 3;
   */
  buySell: Side;

  /**
   * @generated from field: bfftypes.v1.SupplyCategory category = 4;
   */
  category: SupplyCategory;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 5;
   */
  areaCode: AreaCode;

  /**
   * 相対先名称 (プレビュー行の表示用)。
   *
   * @generated from field: string trading_partner_name = 6;
   */
  tradingPartnerName: string;

  /**
   * 反映 (予定) コマ数。
   *
   * @generated from field: int32 changed_koma_count = 7;
   */
  changedKomaCount: number;

  /**
   * 反映対象外コマ数 (GC 済 / 過去日)。
   *
   * @generated from field: int32 skipped_koma_count = 8;
   */
  skippedKomaCount: number;

  /**
   * ERROR 時のみ非空 (backend 生成の日本語文言)。
   *
   * @generated from field: repeated string error_messages = 9;
   */
  errorMessages: string[];

  /**
   * 時間帯区分整合の警告 (AC-S4D-045) がある行のみ非空 (backend 生成の日本語文言)。
   * ERROR とは異なり反映は妨げない (この行は status どおり正常に反映・確定される)。
   *
   * @generated from field: repeated string warning_messages = 10;
   */
  warningMessages: string[];
};

/**
 * Describes the message bffuser.v1.ImportSupply48DataRowResult.
 * Use `create(ImportSupply48DataRowResultSchema)` to create a new message.
 */
export const ImportSupply48DataRowResultSchema: GenMessage<ImportSupply48DataRowResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_service, 5);

/**
 * ImportSupply48DataBreakdown は売買 × カテゴリ別の件数内訳。
 *
 * @generated from message bffuser.v1.ImportSupply48DataBreakdown
 */
export type ImportSupply48DataBreakdown = Message<"bffuser.v1.ImportSupply48DataBreakdown"> & {
  /**
   * @generated from field: bfftypes.v1.Side buy_sell = 1;
   */
  buySell: Side;

  /**
   * @generated from field: bfftypes.v1.SupplyCategory category = 2;
   */
  category: SupplyCategory;

  /**
   * @generated from field: int32 row_count = 3;
   */
  rowCount: number;
};

/**
 * Describes the message bffuser.v1.ImportSupply48DataBreakdown.
 * Use `create(ImportSupply48DataBreakdownSchema)` to create a new message.
 */
export const ImportSupply48DataBreakdownSchema: GenMessage<ImportSupply48DataBreakdown> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_service, 6);

/**
 * ImportSupply48DataSummary は取込全体のサマリ (確定ダイアログ / プレビュー表示の SoT)。
 *
 * @generated from message bffuser.v1.ImportSupply48DataSummary
 */
export type ImportSupply48DataSummary = Message<"bffuser.v1.ImportSupply48DataSummary"> & {
  /**
   * CHANGED (既存行の更新) の行数のみ。NEW は含まない。
   *
   * @generated from field: int32 changed_row_count = 1;
   */
  changedRowCount: number;

  /**
   * @generated from field: int32 unchanged_row_count = 2;
   */
  unchangedRowCount: number;

  /**
   * @generated from field: int32 error_row_count = 3;
   */
  errorRowCount: number;

  /**
   * @generated from field: int32 changed_koma_count = 4;
   */
  changedKomaCount: number;

  /**
   * @generated from field: int32 skipped_koma_count = 5;
   */
  skippedKomaCount: number;

  /**
   * 売買 × カテゴリ別の件数内訳。
   *
   * @generated from field: repeated bffuser.v1.ImportSupply48DataBreakdown breakdowns = 6;
   */
  breakdowns: ImportSupply48DataBreakdown[];

  /**
   * NEW (新規作成) の行数。
   *
   * @generated from field: int32 new_row_count = 7;
   */
  newRowCount: number;

  /**
   * 時間帯区分整合の警告 (AC-S4D-045) を 1 件以上含む行数。CHANGED/NEW/UNCHANGED
   * いずれの status でも警告を持ちうるため status 別カウントとは独立に数える。
   * frontend の「アップロードを確定」ダイアログはこの値を明示し、AC-S4D-045 の
   * 「確認ダイアログで表示し、確認の上で保存を許可する」を成立させる。
   *
   * @generated from field: int32 warning_row_count = 8;
   */
  warningRowCount: number;

  /**
   * delete=1 (DELETED status) の行数 (AC-DUC-013、csv_upload_history.deleted_count
   * へ写像される)。
   *
   * @generated from field: int32 deleted_row_count = 9;
   */
  deletedRowCount: number;
};

/**
 * Describes the message bffuser.v1.ImportSupply48DataSummary.
 * Use `create(ImportSupply48DataSummarySchema)` to create a new message.
 */
export const ImportSupply48DataSummarySchema: GenMessage<ImportSupply48DataSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_service, 7);

/**
 * @generated from message bffuser.v1.ImportSupply48DataResponse
 */
export type ImportSupply48DataResponse = Message<"bffuser.v1.ImportSupply48DataResponse"> & {
  /**
   * true = 反映済み (dry_run=false かつ行エラー 0)。false = プレビューのみ、または行エラーで不成立。
   *
   * @generated from field: bool applied = 1;
   */
  applied: boolean;

  /**
   * @generated from field: repeated bffuser.v1.ImportSupply48DataRowResult row_results = 2;
   */
  rowResults: ImportSupply48DataRowResult[];

  /**
   * @generated from field: bffuser.v1.ImportSupply48DataSummary summary = 3;
   */
  summary?: ImportSupply48DataSummary;
};

/**
 * Describes the message bffuser.v1.ImportSupply48DataResponse.
 * Use `create(ImportSupply48DataResponseSchema)` to create a new message.
 */
export const ImportSupply48DataResponseSchema: GenMessage<ImportSupply48DataResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_48_data_service, 8);

/**
 * ImportSupply48DataRowStatus は取込行 1 行の判定結果を表す。
 *
 * @generated from enum bffuser.v1.ImportSupply48DataRowStatus
 */
export enum ImportSupply48DataRowStatus {
  /**
   * @generated from enum value: IMPORT_SUPPLY48_DATA_ROW_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 既存行があり、反映対象コマが 1 つ以上 (NEW は含まない)。
   *
   * @generated from enum value: IMPORT_SUPPLY48_DATA_ROW_STATUS_CHANGED = 1;
   */
  CHANGED = 1,

  /**
   * 全コマ据え置き (変更なし)。
   *
   * @generated from enum value: IMPORT_SUPPLY48_DATA_ROW_STATUS_UNCHANGED = 2;
   */
  UNCHANGED = 2,

  /**
   * 行エラー (確定不可)。
   *
   * @generated from enum value: IMPORT_SUPPLY48_DATA_ROW_STATUS_ERROR = 3;
   */
  ERROR = 3,

  /**
   * 確定時に (供給源, 受渡日) の 48 点行が新規作成される
   * (既存行なし + 反映対象コマ 1 以上)。
   *
   * @generated from enum value: IMPORT_SUPPLY48_DATA_ROW_STATUS_NEW = 4;
   */
  NEW = 4,

  /**
   * delete=1 の行 (AC-SUPPLY-026)。対象の (供給源, 受渡日) の 48 コマを
   * 全て論理削除し、コマの値も消去する (AC-SUPPLY-027)。
   * changed_koma_count は「空にするコマ数」(= 削除前に値があったコマ数) で、
   * summary の changed_koma_count にも加算される — AC-SUPPLY-029 が削除を
   * 「48 コマを空にした変更」と定義しているため、値変更と同じ軸で数える。
   * skipped_koma_count は 0 (削除は GC 済みコマを含まない日にしか成立しない)。
   *
   * @generated from enum value: IMPORT_SUPPLY48_DATA_ROW_STATUS_DELETED = 5;
   */
  DELETED = 5,
}

/**
 * Describes the enum bffuser.v1.ImportSupply48DataRowStatus.
 */
export const ImportSupply48DataRowStatusSchema: GenEnum<ImportSupply48DataRowStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_48_data_service, 0);

/**
 * @generated from service bffuser.v1.Supply48DataService
 */
export const Supply48DataService: GenService<{
  /**
   * ListSupply48Data は指定期間・カテゴリ・エリアの 48 点データを供給源 (Supply48DataSource) 単位で返す。
   * 比較モード「前日計画」はフロントが date_from を 1 日前に広げて同 RPC を呼ぶだけ (専用 RPC 不要)。
   *
   * @generated from rpc bffuser.v1.Supply48DataService.ListSupply48Data
   */
  listSupply48Data: {
    methodKind: "unary";
    input: typeof ListSupply48DataRequestSchema;
    output: typeof ListSupply48DataResponseSchema;
  },
  /**
   * SaveSupply48Data は複数行を 1 トランザクションで一括保存する。
   *
   * @generated from rpc bffuser.v1.Supply48DataService.SaveSupply48Data
   */
  saveSupply48Data: {
    methodKind: "unary";
    input: typeof SaveSupply48DataRequestSchema;
    output: typeof SaveSupply48DataResponseSchema;
  },
  /**
   * ImportSupply48Data は CSV 取込 (取引ID, 日付, コマ1〜48) を検証・反映する
   * (dry_run=true でプレビュー、false で確定)。acting_member_id は
   * BFF handler が eauth セッションから解決する。
   *
   * @generated from rpc bffuser.v1.Supply48DataService.ImportSupply48Data
   */
  importSupply48Data: {
    methodKind: "unary";
    input: typeof ImportSupply48DataRequestSchema;
    output: typeof ImportSupply48DataResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_supply_48_data_service, 0);

